<template>
<div class="chapter">
<div class="inner_page">
<h2 class="partnum"><a id="page_1"></a>PART I</h2>
<h2 class="parttitle">The Slenderness of Bones<a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Part01.vue?f8101214